/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Pribyl (pribyl@cadwork.cz)
 *
 */

import RenderObject from "App/geometry/objects/object";
import {generate3DLine} from "App/utils/utils";
import Factory from "App/geometry/objects_geometry/factory";
import AbstractGeometry from "App/geometry/objects_geometry/abstract_geometry";
import LineBinary from "App/geometry/objects_geometry/line_binary";

export default
class IndexedLineSet extends LineBinary {

    public static TypeName: string = "indexedLineSet";

    constructor(aObject: RenderObject) {
        super(aObject);
    }

    public static create(aObject: RenderObject) {
        return new IndexedLineSet(aObject);
    }

    public loadData(aBuffer: Uint8Array) {
        let data = {
            positions: new Float32Array(this.properties.positions),
            indices: new Uint32Array(this.properties.indices)
        };

        // transform according to repetition
        let repetitionTrafo = this.object.getElement().getRepetitionTransformation();
        if (repetitionTrafo) {
            data.positions =
                AbstractGeometry.transformArray(
                    data.positions,
                    this.properties.vertexCount,
                    new Float32Array(repetitionTrafo)
                );
        }

        let generatedData: any = {
            positions: [],
            normals: [],
            indices: [],
            distances: []
        };

        generate3DLine(data, generatedData);

        generatedData.positions = new Float32Array(generatedData.positions);
        generatedData.normals = new Float32Array(generatedData.normals);
        generatedData.distances = new Float32Array(generatedData.distances);
        generatedData.indices = new Uint32Array(generatedData.indices);

        this.setDescriptors(generatedData);

        generatedData = null;
        data = null;
    }
}

Factory.register(IndexedLineSet);
